module.exports = __webpack_public_path__ + "static/media/bg.0aaff9a4.png";